import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { table } from "react-bootstrap";
import RescheduleIcon from "assets/svgs/reschedule_summary";
import PastCallIcon from "assets/svgs/past_call";
import ScheduleTodayIcon from "assets/svgs/schedule_today";
import HourlyIcon from "assets/svgs/hourly_summary";
import AnsweredIcon from "assets/svgs/summary_answered";
import UnAnswerIcon from "assets/svgs/unanswer_icon";
import AttemptIcon from "assets/svgs/summary_attempt";
import TalkTimeIcon from "assets/svgs/talktime";
import RescheduleTodayIcon from "assets/svgs/reschedule_today";
import AscendingLogo from "assets/img/illustrations/AscendingLogo";
import DescendingLogo from "assets/img/illustrations/DescendingLogo";
import moment from "moment";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";

export function EngagementNewTable({ summaryData }) {
  const [showColumn, setShowColumn] = useState(false);
  const [opa, setOpa] = useState("");
  const [opa1, setOpa1] = useState("");
  const [opa2, setOpa2] = useState("");
  const [opa3, setOpa3] = useState("");
  const [opa4, setOpa4] = useState("");
  const [opa5, setOpa5] = useState("");
  const [opa6, setOpa6] = useState("");
  const [opa7, setOpa7] = useState("");
  const [opa8, setOpa8] = useState("");
  const [opa9, setOpa9] = useState("");
  const [opa10, setOpa10] = useState("");
  const [count, setCount] = useState(0);
  const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(0);
  const [count3, setCount3] = useState(0);
  const [count4, setCount4] = useState(0);
  const [count5, setCount5] = useState(0);
  const [count6, setCount6] = useState(0);
  const [count7, setCount7] = useState(0);
  const [count8, setCount8] = useState(0);
  const [count9, setCount9] = useState(0);
  const [count10, setCount10] = useState(0);
  const [tableData, setTableData] = useState(summaryData);
  const [reserveTable, setReserveTable] = useState(summaryData);

  useEffect(() => {
    setTableData(summaryData);
    setReserveTable(summaryData);
  }, [summaryData]);

  const getCount = (data) => {
    let count = 0;
    if (reserveTable && reserveTable["_id"] && reserveTable["_id"]["hour"]) {
      Object.keys(reserveTable["_id"]["hour"])?.forEach((key) => {
        const totalHourData = reserveTable["_id"]["hour"][key];
        if (key !== "totalTimeSpent") {
          Object.keys(totalHourData)?.forEach((innerKey) => {
            if (
              [
                "Week #1",
                "Week #3",
                "Prescription Call",
                "retention",
                "SLOT_BOOKING",
                "IVR Booking",
                "Feedback Call",
                "Adhoc Call",
                "Concern Call",
              ].includes(innerKey)
            ) {
              count += totalHourData[innerKey];
            }
          });
        }
      });
    }
    return count;
  };

  const sortByDate = () => {
    if (count === 0) {
      setOpa("dsc");
      setCount(1);
      setTableData([
        ...reserveTable?.sort(
          (a, b) => moment(a?._id?.date) - moment(b?._id?.date)
        ),
      ]);
    } else if (count === 1) {
      setOpa("asc");
      setCount(2);
      setTableData([
        ...reserveTable?.sort(
          (a, b) => moment(b?._id?.date) - moment(a?._id?.date)
        ),
      ]);
    } else if (count === 2) {
      setOpa("");
      setCount(0);
      setTableData([...reserveTable]);
    }
  };

  const handlePastSchedule = () => {
    let pastReschedule = [...tableData];

    if (count1 === 0) {
      setOpa1("dsc");
      setCount1(1);
      pastReschedule.sort((a, b) => {
        const aCount = Object.values(a._id.assignedEngagements || {}).reduce(
          (sum, curr) => sum + curr.rescheduleCount,
          0
        );
        const bCount = Object.values(b._id.assignedEngagements || {}).reduce(
          (sum, curr) => sum + curr.rescheduleCount,
          0
        );
        return bCount - aCount;
      });
    } else if (count1 === 1) {
      setOpa1("asc");
      setCount1(2);
      pastReschedule.sort((a, b) => {
        const aCount = Object.values(a._id.assignedEngagements || {}).reduce(
          (sum, curr) => sum + curr.rescheduleCount,
          0
        );
        const bCount = Object.values(b._id.assignedEngagements || {}).reduce(
          (sum, curr) => sum + curr.rescheduleCount,
          0
        );
        return aCount - bCount;
      });
    } else if (count1 === 2) {
      setOpa1("");
      setCount1(0);
      pastReschedule = [...reserveTable];
      // No sorting needed in this case
    }

    setTableData(pastReschedule);
  };

  const handleUnAnswer = () => {
    let unAnswer = [...tableData];

    if (count6 === 0) {
      setOpa6("dsc");
      setCount6(1);
      unAnswer.sort((a, b) => {
        const aCount = Object.values(a._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.total_attempts,
          0
        );
        const bCount = Object.values(b._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.total_attempts,
          0
        );
        return bCount - aCount;
      });
    } else if (count6 === 1) {
      setOpa6("asc");
      setCount6(2);
      unAnswer.sort((a, b) => {
        const aCount = Object.values(a._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.total_attempts,
          0
        );
        const bCount = Object.values(b._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.total_attempts,
          0
        );
        return aCount - bCount;
      });
    } else if (count6 === 2) {
      setOpa6("");
      setCount6(0);
      unAnswer = [...reserveTable];
      // No sorting needed in this case
    }
    setTableData(unAnswer);
  };

  const handlePastCalls = () => {
    let pastCall = [...tableData];

    if (count2 === 0) {
      setOpa2("dsc");
      setCount2(1);
      pastCall.sort((a, b) => {
        const aCount = Object.values(a._id.assignedEngagements || {}).reduce(
          (sum, curr) => sum + curr.unansweredCount,
          0
        );
        const bCount = Object.values(b._id.assignedEngagements || {}).reduce(
          (sum, curr) => sum + curr.unansweredCount,
          0
        );
        return bCount - aCount;
      });
    } else if (count2 === 1) {
      setOpa2("asc");
      setCount2(2);
      pastCall.sort((a, b) => {
        const aCount = Object.values(a._id.assignedEngagements || {}).reduce(
          (sum, curr) => sum + curr.unansweredCount,
          0
        );
        const bCount = Object.values(b._id.assignedEngagements || {}).reduce(
          (sum, curr) => sum + curr.unansweredCount,
          0
        );
        return aCount - bCount;
      });
    } else if (count2 === 2) {
      setOpa2("");
      setCount2(0);
      pastCall = [...reserveTable];
      // No sorting needed in this case
    }

    setTableData(pastCall);
  };

  const handleHourly = () => {
    let scheduleHourly = [...tableData];

    if (count4 === 0) {
      setOpa4("dsc");
      setCount4(1);
      scheduleHourly.sort((a, b) => {
        const aCount = getCount(a);
        const bCount = getCount(b);
        return bCount - aCount;
      });
    } else if (count4 === 1) {
      setOpa4("asc");
      setCount4(2);
      scheduleHourly.sort((a, b) => {
        const aCount = getCount(a);
        const bCount = getCount(b);
        return aCount - bCount;
      });
    } else if (count4 === 2) {
      setOpa4("");
      setCount4(0);
      scheduleHourly = [...reserveTable];
    }

    setTableData(scheduleHourly);
  };

  const handleScheduleToday = () => {
    let scheduleToday = [...tableData];

    if (count3 === 0) {
      setOpa3("dsc");
      setCount3(1);
      scheduleToday.sort((a, b) => {
        const aCount = Object.values(a._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.allScheduledCalls,
          0
        );
        const bCount = Object.values(b._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.allScheduledCalls,
          0
        );
        return bCount - aCount;
      });
    } else if (count3 === 1) {
      setOpa3("asc");
      setCount3(2);
      scheduleToday.sort((a, b) => {
        const aCount = Object.values(a._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.allScheduledCalls,
          0
        );
        const bCount = Object.values(b._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.allScheduledCalls,
          0
        );
        return aCount - bCount;
      });
    } else if (count3 === 2) {
      setOpa3("");
      setCount3(0);
      scheduleToday = [...reserveTable];
    }

    setTableData(scheduleToday);
  };

  const handleAnswer = () => {
    let answered = [...tableData];
    if (count5 === 0) {
      setOpa5("dsc");
      setCount5(1);
      answered.sort((a, b) => {
        const aCount = Object.values(a._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.answeredCount,
          0
        );
        const bCount = Object.values(b._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.answeredCount,
          0
        );
        return bCount - aCount;
      });
    } else if (count5 === 1) {
      setOpa5("asc");
      setCount5(2);
      answered.sort((a, b) => {
        const aCount = Object.values(a._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.answeredCount,
          0
        );
        const bCount = Object.values(b._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.answeredCount,
          0
        );
        return aCount - bCount;
      });
    } else if (count5 === 2) {
      setOpa5("");
      setCount5(0);
      answered = [...reserveTable];
    }

    setTableData(answered);
  };

  const handleTotalAttempts = () => {
    let totalAttempt = [...tableData];
    if (count7 === 0) {
      setOpa7("dsc");
      setCount7(1);
      totalAttempt.sort((a, b) => {
        const aCount = Object.values(a._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.total_attempts,
          0
        );
        const bCount = Object.values(b._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.total_attempts,
          0
        );
        return bCount - aCount;
      });
    } else if (count7 === 1) {
      setOpa7("asc");
      setCount7(2);
      totalAttempt.sort((a, b) => {
        const aCount = Object.values(a._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.total_attempts,
          0
        );
        const bCount = Object.values(b._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.total_attempts,
          0
        );
        return aCount - bCount;
      });
    } else if (count7 === 2) {
      setOpa7("");
      setCount7(0);
      totalAttempt = [...reserveTable];
    }

    setTableData(totalAttempt);
  };

  const handleRescheduleToday = () => {
    let rescheduleToday = [...tableData];
    if (count8 === 0) {
      setOpa8("dsc");
      setCount8(1);
      rescheduleToday.sort((a, b) => {
        const aCount = Object.values(a._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.rescheduledCount,
          0
        );
        const bCount = Object.values(b._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.rescheduledCount,
          0
        );
        return bCount - aCount;
      });
    } else if (count8 === 1) {
      setOpa8("asc");
      setCount8(2);
      rescheduleToday.sort((a, b) => {
        const aCount = Object.values(a._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.rescheduledCount,
          0
        );
        const bCount = Object.values(b._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.rescheduledCount,
          0
        );
        return aCount - bCount;
      });
    } else if (count8 === 2) {
      setOpa8("");
      setCount8(0);
      rescheduleToday = [...reserveTable];
    }

    setTableData(rescheduleToday);
  };

  const handleTalkTime = () => {
    let talkTime = [...tableData];
    if (count9 === 0) {
      setOpa9("dsc");
      setCount9(1);
      talkTime.sort((a, b) => {
        const aCount = Object.values(a._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.attemptDuration,
          0
        );
        const bCount = Object.values(b._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.attemptDuration,
          0
        );
        return bCount - aCount;
      });
    } else if (count9 === 1) {
      setOpa9("asc");
      setCount9(2);
      talkTime.sort((a, b) => {
        const aCount = Object.values(a._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.attemptDuration,
          0
        );
        const bCount = Object.values(b._id.completedEngagements || {}).reduce(
          (sum, curr) => sum + curr.attemptDuration,
          0
        );
        return aCount - bCount;
      });
    } else if (count9 === 2) {
      setOpa9("");
      setCount9(0);
      talkTime = [...reserveTable];
    }

    setTableData(talkTime);
  };

  const toggleColumn = () => {
    setShowColumn(!showColumn);
  };

  const handleClick = () => {};
  const headers = [
    'Past Reschedule',
    'Past Calls',
    'Schedule Today',
    'Hourly',
    'Answered',
    'Unanswered',
    'Total Attempts',
    'Reschedule Today',
    'TalkTime'
  ];
  
  let countColumn = 0;
  const tdElements = headers.map((header, index) => {
    if (countColumn < 9) {
      countColumn++;
      return <td key={index} className="text-center align-top">{header}</td>;
    }
    return null; // or any other value you prefer
  });

  return (
    <>
      <div className="scrollable-container">
        <OverlayTrigger
          overlay={
            <Tooltip style={{ position: "fixed" }} id="overlay-trigger-example">
              <span className="fw-bold">Click to show total count</span>
            </Tooltip>
          }
        >
          <Button
            style={{ width: "10.8rem", marginRight: "0.5rem" }}
            onClick={toggleColumn}
            className="float-end mb-1 ml-n5 px-3"
          >
            <small className="mr-5">
              {showColumn ? "Hide Total Count" : "Show Total Count"}
            </small>
          </Button>
        </OverlayTrigger>
        <div
          className="w-100 scrollable-container"
          style={{ overflow: "auto", marginTop: "rem", maxHeight: "45rem" }}
        >
          <table
            className="table table-responsive table-striped table-bordered table-hover"
            style={{ border: "2px solid white" }}
          >
            <thead
              className="bg-primary text-white"
              style={{ backgroundColor: "#2222cc" }}
            >
              <tr>
                <th
                  style={{
                    position: "sticky",
                    left: 0,
                    top: 0,
                    zIndex: "4",
                    minWidth: "14rem",
                    backgroundColor: "#2222cc",
                  }}
                  className="text-center "
                >
                  Name
                </th>
                <th
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: "4",
                    left: "14rem",
                    backgroundColor: "#2222cc",
                  }}
                  className="text-center"
                >
                  Date
                </th>
                <th
                  className="text-center p-3"
                  colSpan="9"
                  style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#2222cc",
                    // zIndex: "2",
                  }}
                >
                  Week 1
                </th>
                <th
                  className="text-center p-3"
                  colSpan="9"
                  style={{
                    position: "sticky",
                    backgroundColor: "#2222cc",
                    top: 0,
                    // zIndex: "1",
                  }}
                >
                  Week 3
                </th>
                <th
                  className="text-center p-3"
                  colSpan="9"
                  style={{
                    position: "sticky",
                    backgroundColor: "#2222cc",
                    top: 0,
                    zIndex: "0",
                  }}
                >
                  Prescription
                </th>
                <th
                  className="text-center p-3"
                  colSpan="9"
                  style={{
                    position: "sticky",
                    backgroundColor: "#2222cc",
                    zIndex: "0",
                    top: 0,
                  }}
                >
                  Slot Booking
                </th>
                <th
                  className="text-center p-3"
                  colSpan="9"
                  style={{
                    position: "sticky",
                    backgroundColor: "#2222cc",
                    top: 0,
                    zIndex: "0",
                  }}
                >
                  Retention
                </th>
                <th
                  className="text-center p-3"
                  colSpan="9"
                  style={{
                    position: "sticky",
                    backgroundColor: "#2222cc",
                    zIndex: "0",
                    top: 0,
                  }}
                >
                  IVR Booking
                </th>
                <th
                  className="text-center p-3"
                  colSpan="9"
                  style={{
                    position: "sticky",
                    backgroundColor: "#2222cc",
                    zIndex: "0",
                    top: 0,
                  }}
                >
                  Feedback Call
                </th>
                <th
                  className="text-center p-3"
                  colSpan="9"
                  style={{
                    position: "sticky",
                    backgroundColor: "#2222cc",
                    zIndex: "0",
                    top: 0,
                  }}
                >
                  Adhoc Call
                </th>
                <th
                  className="text-center p-3"
                  colSpan="9"
                  style={{
                    position: "sticky",
                    backgroundColor: "#2222cc",
                    zIndex: "0",
                    top: 0,
                  }}
                >
                  Concern Call
                </th>
                {showColumn && (
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      right: 0,
                      top: 0,
                      zIndex: "2",
                      backgroundColor: "#2222cc",
                    }}
                    colSpan="9"
                  >
                    Total Count
                  </th>
                )}
              </tr>
              <tr>
                <td
                  className="text-center align-top"
                  style={{
                    position: "sticky",
                    left: 0,
                    minWidth: "14rem",
                    backgroundColor: "#2222cc",
                  }}
                >
                  {" "}
                </td>
                <td
                  className="text-center align-top"
                  style={{
                    position: "sticky",
                    left: "14rem",
                    backgroundColor: "#2222cc",
                  }}
                  onClick={sortByDate}
                >
                  {" "}
                  <div
                    style={{
                      display: "inline-block",
                      verticalAlign: "middle",
                      // paddingRight: "0.8rem",
                    }}
                    className="cursor-pointer"
                  >
                    <div
                      className={
                        opa === ""
                          ? "opacity-100"
                          : opa === "asc"
                          ? "opacity-50"
                          : "opacity-100"
                      }
                    >
                      <AscendingLogo />
                    </div>
                    <div
                      className={
                        opa === ""
                          ? "opacity-100"
                          : opa === "dsc"
                          ? "opacity-50"
                          : "opacity-100"
                      }
                    >
                      <DescendingLogo />
                    </div>
                  </div>
                </td>
                {tdElements}
                {tdElements}
                {tdElements}
                {tdElements}
                {tdElements}
                {tdElements}
                {tdElements}
                {tdElements}
                {tdElements}
                {showColumn && (
                  <div
                    className=""
                    style={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#2222cc",
                    }}
                  >
                    <tr rowSpan="2 table-bordered">
                      <OverlayTrigger
                        overlay={
                          <Tooltip
                            style={{ position: "fixed" }}
                            id="overlay-trigger-example"
                          >
                            Past Reschedule
                          </Tooltip>
                        }
                      >
                        <td className="text-center align-top px-3 ">
                          <RescheduleIcon />{" "}
                        </td>
                      </OverlayTrigger>
                      <OverlayTrigger
                        overlay={
                          <Tooltip
                            style={{ position: "fixed" }}
                            id="overlay-trigger-example"
                          >
                            Past Calls
                          </Tooltip>
                        }
                      >
                        <td className="text-center align-top px-3 ">
                          <PastCallIcon />
                        </td>
                      </OverlayTrigger>
                      <OverlayTrigger
                        overlay={
                          <Tooltip
                            style={{ position: "fixed" }}
                            id="overlay-trigger-example"
                          >
                            Schedule Today
                          </Tooltip>
                        }
                      >
                        <td className="text-center align-top px-3 ">
                          <ScheduleTodayIcon />
                        </td>
                      </OverlayTrigger>
                      <OverlayTrigger
                        overlay={
                          <Tooltip
                            style={{ position: "fixed" }}
                            id="overlay-trigger-example"
                          >
                            Hourly
                          </Tooltip>
                        }
                      >
                        <td className="text-center align-top px-3 ">
                          <HourlyIcon />
                        </td>
                      </OverlayTrigger>
                      <OverlayTrigger
                        overlay={
                          <Tooltip
                            style={{ position: "fixed" }}
                            id="overlay-trigger-example"
                          >
                            Answered
                          </Tooltip>
                        }
                      >
                        <td className="text-center align-top px-3 ">
                          <AnsweredIcon />
                        </td>
                      </OverlayTrigger>
                      <OverlayTrigger
                        overlay={
                          <Tooltip
                            style={{ position: "fixed" }}
                            id="overlay-trigger-example"
                          >
                            Unanswered
                          </Tooltip>
                        }
                      >
                        <td className="text-center align-top px-3 ">
                          <UnAnswerIcon />
                        </td>
                      </OverlayTrigger>
                      <OverlayTrigger
                        overlay={
                          <Tooltip
                            style={{ position: "fixed" }}
                            id="overlay-trigger-example"
                          >
                            Total Attempts
                          </Tooltip>
                        }
                      >
                        <td className="text-center align-top px-3 ">
                          <AttemptIcon />
                        </td>
                      </OverlayTrigger>
                      <OverlayTrigger
                        overlay={
                          <Tooltip
                            style={{ position: "fixed" }}
                            id="overlay-trigger-example"
                          >
                            Reschedule Today
                          </Tooltip>
                        }
                        handlePastSchedule
                      >
                        <td className="text-center align-top px-3 ">
                          <RescheduleTodayIcon />
                        </td>
                      </OverlayTrigger>
                      <OverlayTrigger
                        overlay={
                          <Tooltip
                            style={{ position: "fixed" }}
                            id="overlay-trigger-example"
                          >
                            Talktime
                          </Tooltip>
                        }
                      >
                        <td className="text-center align-top px-3 ">
                          <TalkTimeIcon />
                        </td>
                      </OverlayTrigger>
                    </tr>
                    <tr>
                      <td className="align-left cursor-pointer">
                        <div
                          style={{
                            display: "inline-block",
                            verticalAlign: "middle",
                            paddingRight: "0.8rem",
                          }}
                        >
                          <div
                            className={
                              opa1 === ""
                                ? "opacity-100"
                                : opa1 === "asc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                            onClick={handlePastSchedule}
                          >
                            <AscendingLogo />
                          </div>
                          <div
                            className={
                              opa1 === ""
                                ? "opacity-100"
                                : opa1 === "dsc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <DescendingLogo />
                          </div>
                        </div>
                      </td>
                      <td className="text-center align-top cursor-pointer">
                        {" "}
                        <div
                          style={{
                            display: "inline-block",
                            verticalAlign: "middle",
                            // paddingRight: "0.8rem",
                          }}
                          onClick={handlePastCalls}
                        >
                          <div
                            className={
                              opa2 === ""
                                ? "opacity-100"
                                : opa2 === "asc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <AscendingLogo />
                          </div>
                          <div
                            className={
                              opa2 === ""
                                ? "opacity-100"
                                : opa2 === "dsc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <DescendingLogo />
                          </div>
                        </div>
                      </td>
                      <td className="text-center align-top cursor-pointer">
                        {" "}
                        <div
                          style={{
                            display: "inline-block",
                            verticalAlign: "middle",
                            // paddingRight: "0.8rem",
                          }}
                          onClick={handleScheduleToday}
                        >
                          <div
                            className={
                              opa3 === ""
                                ? "opacity-100"
                                : opa3 === "asc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <AscendingLogo />
                          </div>
                          <div
                            className={
                              opa3 === ""
                                ? "opacity-100"
                                : opa3 === "dsc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <DescendingLogo />
                          </div>
                        </div>
                      </td>
                      <td className="text-center align-top cursor-pointer">
                        {" "}
                        <div
                          style={{
                            display: "inline-block",
                            verticalAlign: "middle",
                            // paddingRight: "0.8rem",
                          }}
                          onClick={handleHourly}
                        >
                          <div
                            className={
                              opa4 === ""
                                ? "opacity-100"
                                : opa4 === "asc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <AscendingLogo />
                          </div>
                          <div
                            className={
                              opa4 === ""
                                ? "opacity-100"
                                : opa4 === "dsc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <DescendingLogo />
                          </div>
                        </div>
                      </td>
                      <td className="text-center align-top cursor-pointer">
                        {" "}
                        <div
                          style={{
                            display: "inline-block",
                            verticalAlign: "middle",
                            // paddingRight: "0.8rem",
                          }}
                          onClick={handleAnswer}
                        >
                          <div
                            className={
                              opa5 === ""
                                ? "opacity-100"
                                : opa5 === "asc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <AscendingLogo />
                          </div>
                          <div
                            className={
                              opa5 === ""
                                ? "opacity-100"
                                : opa5 === "dsc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <DescendingLogo />
                          </div>
                        </div>
                      </td>
                      <td className="text-center align-top cursor-pointer">
                        {" "}
                        <div
                          style={{
                            display: "inline-block",
                            verticalAlign: "middle",
                            // paddingRight: "0.8rem",
                          }}
                          onClick={handleUnAnswer}
                        >
                          <div
                            className={
                              opa6 === ""
                                ? "opacity-100"
                                : opa6 === "asc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <AscendingLogo />
                          </div>
                          <div
                            className={
                              opa6 === ""
                                ? "opacity-100"
                                : opa6 === "dsc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <DescendingLogo />
                          </div>
                        </div>
                      </td>
                      <td className="text-center align-top cursor-pointer">
                        {" "}
                        <div
                          style={{
                            display: "inline-block",
                            verticalAlign: "middle",
                            // paddingRight: "0.8rem",
                          }}
                          onClick={handleTotalAttempts}
                        >
                          <div
                            className={
                              opa7 === ""
                                ? "opacity-100"
                                : opa7 === "asc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <AscendingLogo />
                          </div>
                          <div
                            className={
                              opa7 === ""
                                ? "opacity-100"
                                : opa7 === "dsc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <DescendingLogo />
                          </div>
                        </div>
                      </td>
                      <td className="text-center align-top cursor-pointer">
                        {" "}
                        <div
                          style={{
                            display: "inline-block",
                            verticalAlign: "middle",
                            // paddingRight: "0.8rem",
                          }}
                          onClick={handleRescheduleToday}
                        >
                          <div
                            className={
                              opa8 === ""
                                ? "opacity-100"
                                : opa8 === "asc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <AscendingLogo />
                          </div>
                          <div
                            className={
                              opa8 === ""
                                ? "opacity-100"
                                : opa8 === "dsc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <DescendingLogo />
                          </div>
                        </div>
                      </td>
                      <td className="text-center align-top cursor-pointer">
                        {" "}
                        <div
                          style={{
                            display: "inline-block",
                            verticalAlign: "middle",
                            paddingLeft: "0.8rem",
                          }}
                          onClick={handleTalkTime}
                        >
                          <div
                            className={
                              opa9 === ""
                                ? "opacity-100"
                                : opa9 === "asc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <AscendingLogo />
                          </div>
                          <div
                            className={
                              opa9 === ""
                                ? "opacity-100"
                                : opa9 === "dsc"
                                ? "opacity-50"
                                : "opacity-100"
                            }
                          >
                            <DescendingLogo />
                          </div>
                        </div>
                      </td>
                    </tr>
                  </div>
                )}
              </tr>
            </thead>
            <tbody>
              {tableData?.map((item) => {
                const hourValue = () => {
                  let count = 0;
                  if (value) {
                    Object?.keys(value)?.forEach((key) => {
                      const totalHourData = value[key];
                      if (key !== "totalTimeSpent") {
                        Object.keys(totalHourData)?.forEach((innerKey) => {
                          if (
                            [
                              "Week #1",
                              "Week #3",
                              "Prescription Call",
                              "retention",
                              "SLOT_BOOKING",
                              "IVR Booking",
                              "Feedback Call",
                              "ADHOC_CALL",
                              "Concern Call",
                            ].includes(innerKey)
                          ) {
                            count += totalHourData[innerKey];
                          }
                        });
                      }
                    });
                  }
                  return count.toString();
                };

                const pastReschedule = item?._id?.assignedEngagements
                  ? Object?.values(item?._id?.assignedEngagements).reduce(
                      (sum, curr) => sum + curr?.rescheduleCount,
                      0
                    )
                  : 0;
                const totalAttempts = item?._id?.completedEngagements
                  ? Object?.values(item?._id?.completedEngagements)?.reduce(
                      (sum, curr) => sum + curr?.total_attempts,
                      0
                    )
                  : 0;

                const scheduleToday = item?._id?.completedEngagements
                  ? Object?.values(item?._id?.completedEngagements)?.reduce(
                      (sum, curr) => sum + (curr?.allScheduledCalls || 0),
                      0
                    )
                  : 0;
                const answered = item?._id?.completedEngagements
                  ? Object.values(item?._id?.completedEngagements).reduce(
                      (sum, curr) => sum + +curr?.answeredCount,
                      0
                    )
                  : 0;
                const pastCalls = item?._id?.assignedEngagements
                  ? Object?.values(item?._id?.assignedEngagements)?.reduce(
                      (sum, curr) => sum + curr?.unansweredCount,
                      0
                    )
                  : 0;
                const unAnswered = item?._id?.completedEngagements
                  ? Object?.values(item?._id?.completedEngagements)?.reduce(
                      (sum, curr) => sum + curr?.unansweredCount,
                      0
                    )
                  : 0;
                const rescheduleToday = item?._id?.completedEngagements
                  ? Object?.values(item?._id?.completedEngagements)?.reduce(
                      (sum, curr) => sum + curr?.rescheduledCount,
                      0
                    )
                  : 0;
                const talkTime = item?._id?.completedEngagements
                  ? Object?.values(item?._id?.completedEngagements)?.reduce(
                      (sum, curr) => sum + curr?.attemptDuration,
                      0
                    )
                  : 0;
                return (
                  <tr>
                    <td
                      style={{
                        position: "sticky",
                        left: 0,
                        minWidth: "14rem",
                        backgroundColor: "#C7D2E1",
                      }}
                      className="text-black"
                    >
                      {item?._id?.userName || "-"}
                    </td>
                    <td
                      style={{
                        position: "sticky",
                        left: "14rem",
                        minWidth: "8rem",
                        backgroundColor: "#C7D2E1",
                      }}
                      className="text-black"
                    >
                      {moment(item?._id?.date, "YYYY/MM/DD HH:mm:ss").format(
                        "DD/MM/YYYY HH:mm:ss"
                      )}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.["Week #1"]
                        ?.rescheduleCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.["Week #1"]
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Week #1"]
                        ?.allScheduledCalls || "0"}
                    </td>
                    <td className="text-center">{"0"}</td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Week #1"]
                        ?.answeredCount ||
                        "0" ||
                        "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Week #1"]
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Week #1"]
                        ?.total_attempts || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Week #1"]
                        ?.rescheduledCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Week #1"]
                        ?.attemptDuration || "0"}
                    </td>

                    <td className="text-center">
                      {item?._id?.assignedEngagements?.["Week #3"]
                        ?.rescheduleCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.["Week #3"]
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Week #3"]
                        ?.allScheduledCalls || "0"}
                    </td>
                    <td className="text-center">{"0"}</td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Week #3"]
                        ?.answeredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Week #3"]
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Week #3"]
                        ?.total_attempts || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Week #3"]
                        ?.rescheduledCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Week #3"]
                        ?.attemptDuration || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.["Prescription Call"]
                        ?.rescheduleCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.["Prescription Call"]
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Prescription Call"]
                        ?.allScheduledCalls || "0"}
                    </td>
                    <td className="text-center">{"0"}</td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Prescription Call"]
                        ?.answeredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Prescription Call"]
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Prescription Call"]
                        ?.total_attempts || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Prescription Call"]
                        ?.rescheduledCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.["Prescription Call"]
                        ?.attemptDuration || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.SLOT_BOOKING
                        ?.rescheduleCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.SLOT_BOOKING
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.SLOT_BOOKING
                        ?.allScheduledCalls || "0"}
                    </td>
                    <td className="text-center">{"0"}</td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.SLOT_BOOKING
                        ?.answeredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.SLOT_BOOKING
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.SLOT_BOOKING
                        ?.total_attempts || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.SLOT_BOOKING
                        ?.rescheduledCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.SLOT_BOOKING
                        ?.attemptDuration || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.retention
                        ?.rescheduleCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.retention
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.retention
                        ?.allScheduledCalls || "0"}
                    </td>
                    <td className="text-center">{"0"}</td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.retention
                        ?.answeredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.retention
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.retention
                        ?.total_attempts || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.retention
                        ?.rescheduledCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.retention
                        ?.attemptDuration || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.IVR_BOOKING
                        ?.rescheduleCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.IVR_BOOKING
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.IVR_BOOKING
                        ?.allScheduledCalls || "0"}
                    </td>
                    <td className="text-center">{"0"}</td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.IVR_BOOKING
                        ?.answeredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.IVR_BOOKING
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.IVR_BOOKING
                        ?.total_attempts || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.IVR_BOOKING
                        ?.rescheduledCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.IVR_BOOKING
                        ?.attemptDuration || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.FEEDBACK_CALL
                        ?.rescheduleCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.FEEDBACK_CALL
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.FEEDBACK_CALL
                        ?.allScheduledCalls || "0"}
                    </td>
                    <td className="text-center">{"0"}</td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.FEEDBACK_CALL
                        ?.answeredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.FEEDBACK_CALL
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.FEEDBACK_CALL
                        ?.total_attempts || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.FEEDBACK_CALL
                        ?.rescheduledCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.FEEDBACK_CALL
                        ?.attemptDuration || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.ADHOC_CALL
                        ?.rescheduleCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.ADHOC_CALL
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.ADHOC_CALL
                        ?.allScheduledCalls || "0"}
                    </td>
                    <td className="text-center">{"0"}</td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.ADHOC_CALL
                        ?.answeredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.ADHOC_CALL
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.ADHOC_CALL
                        ?.total_attempts || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.ADHOC_CALL
                        ?.rescheduledCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.ADHOC_CALL
                        ?.attemptDuration || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.concernCall
                        ?.rescheduleCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.assignedEngagements?.concernCall
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.concernCall
                        ?.allScheduledCalls || "0"}
                    </td>
                    <td className="text-center">{"0"}</td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.concernCall
                        ?.answeredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.concernCall
                        ?.unansweredCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.concernCall
                        ?.total_attempts || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.concernCall
                        ?.rescheduledCount || "0"}
                    </td>
                    <td className="text-center">
                      {item?._id?.completedEngagements?.concernCall
                        ?.attemptDuration || "0"}
                    </td>
                    {showColumn && (
                      <div
                        style={{
                          color: "black",
                          position: "sticky",
                          right: 0,
                          backgroundColor: "#C7D2E1",
                          zIndex: "1",
                        }}
                      >
                        <tr rowSpan="2 table-bordered" className="text-black">
                          <td
                            style={{ width: "4.2rem" }}
                            className="text-center align-top p-3"
                          >
                            {pastReschedule?.toFixed(0)}
                          </td>
                          <td
                            style={{ width: "4.2rem" }}
                            className="text-center align-top p-3"
                          >
                            {pastCalls?.toFixed(0)}
                          </td>
                          <td
                            style={{ width: "4.2rem" }}
                            className="text-center align-top p-3"
                          >
                            {scheduleToday}
                          </td>
                          <td
                            style={{ width: "4.2rem" }}
                            className="text-center align-top p-3"
                          >
                            {hourValue.length != 0 ? hourValue : 0}
                          </td>
                          <td
                            style={{ width: "4.2rem" }}
                            className="text-center align-top p-3"
                          >
                            {answered?.toFixed(0)}
                          </td>
                          <td
                            style={{ width: "4.2rem" }}
                            className="text-center align-top p-3"
                          >
                            {unAnswered?.toFixed(0)}
                          </td>
                          <td
                            style={{ width: "4.2rem" }}
                            className="text-center align-top p-3"
                          >
                            {totalAttempts?.toFixed(0)}
                          </td>
                          <td
                            style={{ width: "4.2rem" }}
                            className="text-center align-top p-3"
                          >
                            {rescheduleToday?.toFixed(0)}
                          </td>
                          <td
                            style={{ width: "4.2rem" }}
                            className="text-center align-top p-3"
                          >
                            {talkTime?.toFixed(0)}
                          </td>
                        </tr>
                      </div>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
